import React, { useState, useContext, useEffect } from "react";
import { View, StyleSheet } from "react-native";
import NtText from "../../components/NtText";
import colors from "../../config/colors";
import NtActivityIndicator from "../../components/NtActivityIndicator";
import UserContext from "../../context/UserContext";
import NtModalUnactiveButton from "../../components/NtModalUnactiveButton";
import NtModalActiveButton from "../../components/NtModalActiveButton";
import NtModalInputField from "../../components/NtModalInputField";
import Logger from "../../common/utils/Logger";
import { parseError } from "@ntconnect/framework/pbx";
import NtModalError from "../../components/NtModalError";
import {
  createHardwareFile,
  deleteHardwareFile,
  fetchProvisioningFile,
} from "../../api/hardware";
import hardwareaccountsdata from "../data/hardwareaccountsdata";
import NtTabController from "../../components/NtTabController";
import NtModalAccountPickerField from "./NtModalAccountPickerField";
import hardwaretimezonedata from "../data/hardwaretimezonedata";
import NtHardwareTimezonePicker from "./NtHardwareTimezonePicker";
import NtHardwareRingtonePicker from "./NtHardwareRingtonePicker";
import hardwareringtonedata from "../data/hardwareringtonedata";
import NtModalTitle from "../../components/NtModalTitle";
import NtModalSubtitle from "../../components/NtModalSubtitle";

function NtHardwareUpdateForm({ item, onCancel, onUpdate, onDelete }) {
  const [extension1, setExtension1] = useState("");
  const [extension2, setExtension2] = useState("");
  const [proxy1, setProxy1] = useState("");
  const [proxy2, setProxy2] = useState("");
  const [port1, setPort1] = useState("");
  const [port2, setPort2] = useState("");
  const [ringtone1, setRingtone1] = useState("");
  const [ringtone2, setRingtone2] = useState("");

  const [timezone, setTimezone] = useState();

  const [account, setAccount] = useState(hardwareaccountsdata[0]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const context = useContext(UserContext);

  const isRequiredFields = () => {
    return (extension1 && proxy1 && port1) || (extension2 && proxy2 && port2);
  };

  function xmlToJson(xml) {
    let obj = {};
    if (xml.nodeType === 1) {
      if (xml.attributes.length > 0) {
        obj["@attributes"] = {};
        for (let j = 0; j < xml.attributes.length; j++) {
          let attribute = xml.attributes.item(j);
          obj["@attributes"][attribute.nodeName] = attribute.nodeValue;
        }
      }
    } else if (xml.nodeType === 3) {
      obj = xml.nodeValue;
    }
    if (xml.hasChildNodes()) {
      for (let i = 0; i < xml.childNodes.length; i++) {
        let item = xml.childNodes.item(i);
        let nodeName = item.nodeName;
        if (typeof obj[nodeName] === "undefined") {
          obj[nodeName] = xmlToJson(item);
        } else {
          if (typeof obj[nodeName].push === "undefined") {
            let old = obj[nodeName];
            obj[nodeName] = [];
            obj[nodeName].push(old);
          }
          obj[nodeName].push(xmlToJson(item));
        }
      }
    }
    return obj;
  }

  const parseXml = (xmlString) => {
    let parser = new DOMParser();
    let xml = parser.parseFromString(xmlString, "text/xml");
    const json = xmlToJson(xml);

    let accounts = {};

    hardwareaccountsdata?.map((eachAccount) => {
      let details = {};
      json?.gs_provision?.config?.item?.map((each) => {
        if (
          each["@attributes"]?.name ==
          `account.${eachAccount.id}.sip.outboundProxy.1.address`
        ) {
          details.proxy = each["#text"]?.split(":")[0];
          details.port = each["#text"]?.split(":")[1];
        } else if (
          each["@attributes"]?.name ==
          `account.${eachAccount.id}.sip.server.1.address`
        ) {
          details.domain = each["#text"];
        } else if (
          each["@attributes"]?.name ==
          `account.${eachAccount.id}.sip.subscriber.userid`
        ) {
          details.extension = each["#text"];
        } else if (
          each["@attributes"]?.name ==
          `account.${eachAccount.id}.sip.subscriber.name`
        ) {
          details.name = each["#text"];
        } else if (
          each["@attributes"]?.name ==
          `account.${eachAccount.id}.sip.subscriber.password`
        ) {
          details.password = each["#text"];
        } else if (
          each["@attributes"]?.name == `account.${eachAccount.id}.ring.ringtone`
        ) {
          details.ringtone = each["#text"];
        } else if (each["@attributes"]?.name == `dateTime.timezone`) {
          accounts.timezone = each["#text"];
        }
      });

      if (Object.keys(details)?.length > 0) {
        accounts[eachAccount?.id] = details;
      }
    });

    return accounts;
  };

  const handleFileFetch = async () => {
    setLoading(true);
    setError(null);

    const response = await fetchProvisioningFile(item.status, item.mac);
    Logger("Fetching the file data", response);
    if (response.ok) {
      const data = parseXml(response.data);

      // will now construct the items....
      if (data[1]) {
        setExtension1({
          name: "extension",
          value: data[1]?.extension,
          item: {
            extension: data[1]?.extension,
            password: data[1]?.password,
            effective_caller_id_name: data[1]?.name,
          },
        });
        setProxy1(data[1]?.proxy);
        setPort1(data[1]?.port);
        const ringtoneItem = hardwareringtonedata?.find(
          (each) => each.id == data[1]?.ringtone,
        );
        if (!ringtoneItem) {
          ringtoneItem = hardwareringtonedata[hardwareringtonedata?.length - 1];
        }
        setRingtone1(ringtoneItem);
      }
      if (data[2]) {
        setExtension2({
          name: "extension",
          value: data[2]?.extension,
          item: {
            extension: data[2]?.extension,
            password: data[2]?.password,
            effective_caller_id_name: data[2]?.name,
          },
        });
        setProxy2(data[2]?.proxy);
        setPort2(data[2]?.port);
        const ringtoneItem = hardwareringtonedata?.find(
          (each) => each.id == data[2]?.ringtone,
        );
        if (!ringtoneItem) {
          ringtoneItem = hardwareringtonedata[hardwareringtonedata?.length - 1];
        }
        setRingtone2(ringtoneItem);
      }

      let timezoneItem = null;
      if (data.timezone) {
        timezoneItem = hardwaretimezonedata.find(
          (each) => each.id == data.timezone,
        );
      }

      if (!timezoneItem) {
        timezoneItem = hardwaretimezonedata[0];
      }

      setTimezone(timezoneItem);

      Logger("Just finished the data", data);
    }

    setLoading(false);
  };

  const handleUpdate = async () => {
    setLoading(true);

    setError(null);

    let params = {
      mac: item.mac,
      timezone: timezone?.id,
      domain: context.user?.domain,
    };

    if (extension1 && proxy1 && port1) {
      params.account1 = {
        extension: extension1?.item?.extension,
        password: extension1?.item?.password,
        proxy: proxy1,
        port: port1,
        ringtone: ringtone1?.id,
        name:
          extension1?.item?.effective_caller_id_name ||
          extension1?.item?.extension.substring(4),
      };
    }

    if (extension2 && proxy2 && port2) {
      params.account2 = {
        extension: extension2?.item?.extension,
        password: extension2?.item?.password,
        proxy: proxy2,
        port: port2,
        ringtone: ringtone2?.id,
        name:
          extension2?.item?.effective_caller_id_name ||
          extension2?.item?.extension.substring(4),
      };
    }

    const response = await createHardwareFile(params);

    Logger("Hardware Created", response);

    if (response.ok) {
      if (onUpdate) {
        onUpdate();
      }
    } else {
      setError(parseError(response));
    }

    setLoading(false);
  };

  const handleDelete = async () => {
    setLoading(true);
    setError(null);

    const response = await deleteHardwareFile(item?.mac, item?.status);
    Logger("Hardware Delete Response", response);

    if (response.ok) {
      if (onDelete) {
        onDelete();
      }
    } else {
      setError(parseError(response));
    }

    setLoading(false);
  };

  useEffect(() => {
    handleFileFetch();
  }, []);

  return (
    <View style={styles.container}>
      <NtModalTitle>Update Hardware</NtModalTitle>
      <NtModalSubtitle style={[{ marginTop: 4 }]}>
        Update Hardward Configuration
      </NtModalSubtitle>

      <NtTabController
        containerStyle={{ marginTop: 20 }}
        options={hardwareaccountsdata}
        selection={account}
        onPress={(item) => {
          setAccount(item);
        }}
      />

      <NtModalAccountPickerField
        containerStyle={{ marginTop: 25 }}
        title={"Extension *"}
        placeholder={"Extension *"}
        value={account?.id == "1" ? extension1 : extension2}
        removeOptions={["ringgroup", "recording", "voicemail", "other"]}
        setValue={account?.id == "1" ? setExtension1 : setExtension2}
      />

      <NtModalInputField
        containerStyle={{ marginTop: 15 }}
        title={"Proxy *"}
        placeholder={"Proxy"}
        value={account?.id == "1" ? proxy1 : proxy2}
        setValue={account?.id == "1" ? setProxy1 : setProxy2}
      />
      <NtModalInputField
        containerStyle={{ marginTop: 15 }}
        title={"Port *"}
        placeholder={"Port"}
        value={account?.id == "1" ? port1 : port2}
        setValue={account?.id == "1" ? setPort1 : setPort2}
      />

      <NtHardwareRingtonePicker
        containerStyle={{ marginTop: 20 }}
        selection={account?.id == "1" ? ringtone1 : ringtone2}
        onPress={account?.id == "1" ? setRingtone1 : setRingtone2}
      />

      <NtHardwareTimezonePicker
        containerStyle={{ marginTop: 20 }}
        selection={timezone}
        onPress={(item) => setTimezone(item)}
      />

      <NtModalError error={error} containerStyle={{ marginTop: 6 }} />

      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          marginTop: 40,
        }}
      >
        <View style={{ flexDirection: "row", alignItems: "center" }}>
          {item.status == "pending" && (
            <NtModalActiveButton
              containerStyle={{ backgroundColor: "red" }}
              title={"Delete Configuration File"}
              icon={"delete"}
              onPress={() => {
                handleDelete();
              }}
              enabled={true}
            />
          )}
        </View>

        <View style={{ flexDirection: "row", alignItems: "center" }}>
          {loading && (
            <NtActivityIndicator
              color={colors.blue}
              size="small"
              containerStyle={{ marginRight: 25 }}
            />
          )}

          <NtModalUnactiveButton title={"Cancel"} onPress={onCancel} />

          <NtModalActiveButton
            containerStyle={{ marginLeft: 15 }}
            title={
              item?.voicemail_enabled == "false"
                ? "Update & Activate"
                : "Update"
            }
            onPress={() => {
              if (isRequiredFields()) {
                handleUpdate();
              }
            }}
            enabled={isRequiredFields()}
          />
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    minWidth: 500,
    maxWidth: 600,
    padding: 15,
  },
  fieldTitle: {
    fontSize: 14,
    fontWeight: "700",
    color: colors.darker,
  },
});

export default NtHardwareUpdateForm;
